import React from 'react';
import { InstagramIcon, TiktokIcon, YoutubeIcon, PinterestIcon } from '@revfluence/fresh-icons/brands/esm';
import { GlobeIcon } from '@revfluence/fresh-icons/solid/esm';

export const getSocialIcon = (platform: string) => {
  switch (platform) {
    case 'instagram':
      return <InstagramIcon fontSize={16} />;
    case 'tiktok':
      return <TiktokIcon fontSize={16} />;
    case 'youtube':
      return <YoutubeIcon fontSize={16} />;
    case 'pinterest':
      return <PinterestIcon fontSize={16} />;
    case 'website':
      return <GlobeIcon fontSize={16} />;
    default:
      return <GlobeIcon fontSize={16} />;
  }
};
